import * as z from "zod/v4";

export const getDefaultSenderAddress = {
  name: "getDefaultSenderAddress" as const,
  input: z.object({}),
  output: z.object({ name: z.string(), email: z.string(), domain: z.string() }),
};
